/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { DeliveryType } from "./DeliveryType";
import type { DisplayStatus } from "./DisplayStatus";
import type { FaxProviderData } from "./FaxProviderData";
import type { PhysicalMailProviderData } from "./PhysicalMailProviderData";

export interface OutboundDocumentResponse {
  id: string;
  delivery_type: DeliveryType;
  display_status: DisplayStatus;
  title: string;
  recipient_display_name: string;
  created_at: string;
  updated_at: string;
  preview_image_urls: string[];
  provider_data: FaxProviderData | PhysicalMailProviderData;
}
